import React, { useState } from "react";
import { useEffect } from "react";
import ImageSketlton from "../Loader/ImageSkelton";
import { FaFilePdf, FaRegFilePdf } from "react-icons/fa";
import { Download } from "lucide-react";
import { Eye, X } from "lucide-react";
import { createPortal } from "react-dom";

const ImageSlipModal = ({ isOpen, onClose, fileUrl, imgPreviewLoading }) => {
  const [pdfPreviewClicked, setPdfPreviewClicked] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const pdfUrl = fileUrl; // Replace with your PDF source variable

  useEffect(() => {
    console.log("fileUrl", fileUrl);

    if (fileUrl?.includes("pdf")) {
      console.log("this is pdf");
    } else {
      console.log("this is img");
    }
  }, [fileUrl]);

  const handleDownload = () => {
    if (fileUrl) {
      const link = document.createElement("a");

      link.download = "payment_slip";
      link.href = fileUrl;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const isPdf = fileUrl?.startsWith("data:application/pdf");

  if (!isOpen) return null;

  // Placeholder image if none is provided
  const displayImage =
    fileUrl ||
    "https://placehold.co/600x800/f8fafc/0f172a?text=Receipt+Image+Not+Found";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
      {/* Immersive Glassmorphism Backdrop */}
      <div
        className="absolute inset-0 bg-[#0a1128]/70 backdrop-blur-md transition-opacity"
        onClick={onClose}
      ></div>

      {/* Modal Container - 3D Layered Composition */}
      <div className="relative w-full max-w-lg bg-white rounded-[2rem] shadow-2xl shadow-blue-900/50 overflow-hidden transform transition-all flex flex-col max-h-[90vh]">
        {/* Dark Blue Header with Mesh/Liquid Gradient Feel */}
        <div className="relative shrink-0 bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 px-6 py-5 flex items-center justify-between overflow-hidden z-10">
          {/* Subtle light leaks for a liquid glass effect */}
          <div className="absolute inset-0 w-full h-full opacity-40 pointer-events-none">
            <div className="absolute -top-10 -left-10 w-32 h-32 bg-white rounded-full mix-blend-overlay filter blur-2xl"></div>
            <div className="absolute bottom-[-20%] -right-5 w-40 h-40 bg-blue-400 rounded-full mix-blend-overlay filter blur-3xl"></div>
          </div>

          <div className="relative flex items-center gap-3">
            <div className="w-10 h-10 bg-white/10 backdrop-blur-md rounded-xl flex items-center justify-center border border-white/20 shadow-inner">
              <svg
                className="w-5 h-5 text-blue-200"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
            </div>
            <h2 className="text-lg font-bold text-white tracking-wide">
              Payment Receipt
            </h2>
          </div>

          {/* Explicit Close Button */}
          <button
            onClick={onClose}
            className="relative p-2.5 bg-white/10 hover:bg-white/20 text-white rounded-full backdrop-blur-md border border-white/10 transition-colors focus:outline-none z-20"
            aria-label="Close modal"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.5"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Crisp White Slip Body - Scrollable if image is very tall */}
        <div className="p-6 bg-gray-50/50 flex-1 overflow-y-auto custom-scrollbar flex items-center justify-center min-h-[300px]">
          <div className="relative w-full rounded-2xl overflow-hidden bg-white shadow-sm border border-gray-100 p-2 flex items-center justify-center">
            {/* Inside your component: */}

            {imgPreviewLoading ? (
              <div className="w-full flex justify-center py-10">
                <ImageSketlton />
              </div>
            ) : isPdf ? (
              /* Beautiful PDF State UI (Fits inside your small popup) */
              <div className="flex flex-col items-center justify-center py-6 px-4 text-center w-full">
                {/* 3D Layered Icon Container */}
                <div className="relative mb-4">
                  <div className="absolute inset-0 bg-red-400 blur-2xl opacity-20 rounded-full animate-pulse"></div>
                  <div className="relative w-20 h-20 bg-gradient-to-b from-white to-gray-50 border border-gray-100 shadow-xl shadow-red-900/5 rounded-2xl flex items-center justify-center transform transition-transform hover:scale-105 duration-300">
                    <FaRegFilePdf className="text-4xl text-red-500 drop-shadow-sm" />
                    <div className="absolute -bottom-2 -right-2 bg-red-100 text-red-600 text-[10px] font-bold px-2 py-0.5 rounded-md border border-white shadow-sm">
                      PDF
                    </div>
                  </div>
                </div>

                {/* Typography */}
                <h3 className="text-lg font-extrabold text-blue-950 mb-1 tracking-tight">
                  Document Receipt
                </h3>
                <p className="text-xs text-gray-500 max-w-[240px] mb-6 leading-relaxed">
                  This payment slip is secured as a PDF file. Select an action
                  below.
                </p>

                {/* Action Buttons */}
                <div className="flex items-center justify-center gap-2 w-full max-w-[280px]">
                  {/* Click to Preview Button */}
                  <button
                    type="button"
                    onClick={() => setShowPdfModal(true)}
                    className="flex-1 flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-2.5 rounded-xl font-semibold text-xs transition-all active:scale-95 shadow-sm border border-gray-200/80"
                  >
                    <Eye className="w-4 h-4 text-gray-600" />
                    Preview
                  </button>

                  {/* Elevated Download Button */}
                  <button
                    type="button"
                    onClick={handleDownload}
                    className="flex-1 group relative flex items-center justify-center gap-2 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 text-white px-4 py-2.5 rounded-xl font-semibold text-xs shadow-md shadow-blue-900/20 transition-all hover:shadow-blue-900/40 active:scale-95 overflow-hidden"
                  >
                    <Download className="w-4 h-4" />
                    Download
                    {/* Hover shine effect */}
                    <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]"></div>
                  </button>
                </div>

                {/* FULL-SCREEN PDF PREVIEW MODAL (Rendered via React Portal) */}
                {showPdfModal &&
                  createPortal(
                    <div className="fixed inset-0 z-[9999] flex flex-col bg-black/80 backdrop-blur-sm p-4 sm:p-6 animate-in fade-in duration-200">
                      {/* Top Header Bar */}
                      <div className="flex items-center justify-between pb-3 text-white w-full max-w-6xl mx-auto">
                        <div className="flex items-center gap-2">
                          <FaRegFilePdf className="text-xl text-red-500" />
                          <h3 className="text-sm font-bold tracking-wide">
                            Document Preview
                          </h3>
                        </div>

                        {/* Close Button */}
                        <button
                          type="button"
                          onClick={() => setShowPdfModal(false)}
                          className="flex items-center gap-1.5 px-3 py-1.5 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-colors text-xs font-semibold"
                        >
                          <span>Close</span>
                          <X className="w-4 h-4" />
                        </button>
                      </div>

                      {/* PDF View Area */}
                      <div className="flex-1 w-full max-w-6xl mx-auto bg-white rounded-xl overflow-hidden shadow-2xl border border-white/10">
                        <iframe
                          src={pdfUrl}
                          className="w-full h-full border-0"
                          title="PDF Preview"
                        />
                      </div>
                    </div>,
                    document.body, // Appends modal directly to document.body
                  )}
              </div>
            ) : (
              <img
                src={displayImage}
                alt="Scanned Payment Slip"
                className="w-full h-auto max-h-[50vh] object-contain rounded-xl"
                loading="lazy"
              />
            )}
          </div>
        </div>

        {/* Action Buttons Footer */}
        <div className="p-6 bg-white border-t border-gray-100 shrink-0">
          <div className="flex gap-3">
            {/* <button className="flex-1 bg-blue-50 text-blue-900 py-3.5 px-4 rounded-xl font-bold text-sm hover:bg-blue-100 transition-colors border border-blue-100 flex items-center justify-center gap-2">
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                />
              </svg>
              Share Image
            </button> */}
            <button
              onClick={handleDownload}
              className="flex-1 active:scale-95 active:bg-black bg-blue-900 text-white py-3.5 px-4 rounded-xl font-bold text-sm hover:bg-blue-800 shadow-lg shadow-blue-900/30 transition-all flex items-center justify-center gap-2"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageSlipModal;
